import LOGOSVG from '../../../../assets/icons/logo-white.svg';
import { InvoiceFooterStyled } from './style';

const InvoiceFooter = () => {
  return (
    <InvoiceFooterStyled>
      <div className="footer-main">
        <p>This invoice is generated by Escape plan</p>
        <div className="footer-icon-data">
          <img src={LOGOSVG} alt="logo" />
          <div>
            <p>Evacuation Plans</p>
            <p>SaaS Application</p>
          </div>
        </div>
      </div>
    </InvoiceFooterStyled>
  );
};

export default InvoiceFooter;
